import { css } from 'lit';

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: block;
	}

	.p {
		padding: 5px;
	}

	.row {
		line-height: 22px;
	}

	og-dropdown-list {
		height: 22px;
	}

	og-input {
		display: block;
	}

	.item-content {
		height: 100%;
		display: flex;
		flex-direction: row;
	}

	.item-form {
		flex: 1;
	}

	.item-controls {
		flex: 0;
		padding: 0 2px;
		display: flex;
		flex-direction: column;
		gap: 2px;
	}
	
	.item-controls og-button {
		width: 24px;
		display: block;
	}
`;